import React from 'react';
import {
  Box,
  CssBaseline,
  ThemeProvider,
} from '@mui/material';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import { lightTheme, darkTheme } from '../../theme';
import AppBar from './AppBar';
import Sidebar from './Sidebar';
import DemoBanner from './DemoBanner';
import NotificationCenter from './NotificationCenter';
import DialogManager from '../Dialogs/DialogManager';
import InstallBanner from '../PWA/InstallBanner';
import UpdateNotification from '../PWA/UpdateNotification';

interface AppLayoutProps {
  children: React.ReactNode;
}

const DEMO_BANNER_HEIGHT = 44;

const AppLayout: React.FC<AppLayoutProps> = ({ children }) => {
  const theme = useSelector((state: RootState) => state.ui.theme);
  const { user, organization } = useSelector((state: RootState) => state.auth);
  const isGuest = user?.userEmail === '' && !organization;

  const currentTheme = theme === 'dark' ? darkTheme : lightTheme;

  return (
    <ThemeProvider theme={currentTheme}>
      <CssBaseline />
      <Box sx={{ display: 'flex' }}>
        <AppBar />
        <Sidebar />
        <DemoBanner />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 3,
            marginTop: isGuest ? `${64 + DEMO_BANNER_HEIGHT}px` : '64px', // Height of AppBar + optional DemoBanner
            marginLeft: '60px', // Fixed width regardless of sidebar state
            transition: theme => theme.transitions.create(['margin'], {
              easing: theme.transitions.easing.easeOut,
              duration: theme.transitions.duration.standard,
            }),
            minHeight: 'calc(100vh - 64px)',
            backgroundColor: currentTheme.palette.background.default,
          }}
        >
          {children}
        </Box>
        <NotificationCenter />
        <DialogManager />
        <InstallBanner />
        <UpdateNotification />
      </Box>
    </ThemeProvider>
  );
};

export default AppLayout;